import { find as _find } from 'lodash';
import { without as _without } from 'lodash';
import { filter as _filter } from 'lodash';

class PriceContainerController {
  constructor($stateParams, lookupService, loadingService, priceManagementService) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.lookupService = lookupService;
    this.loadingService = loadingService;
    this.priceManagementService = priceManagementService;

    this.priceLookups = [];
    this.formula = '';
    this.priceFormula = '';
    this.formulaExpression = '';
    this.formulaEvaluated = '';
    this.initializePrices();

    this.state = '';
    this.resetNotification();
  }

  resetNotification() {
    this.notification = {
      type: '',
      msg: ''
    };
  }

  initializePrices() {
    const ctrl = this;

    ctrl.loadingService.showLoading('priceList', 'Loading Price List ...');

    ctrl.lookupService.lookupPriceLookups(ctrl.$stateParams.locationId)
      .then(priceLookups => {
        priceLookups.map(p => {
          p.random = ctrl.getRandomInt(1, 10);
        });
        ctrl.priceLookups = priceLookups;

        ctrl.initializeFormula();
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('priceList');
      });
  }

  initializeFormula() {
    const ctrl = this;

    ctrl.priceManagementService.getPriceFormula(ctrl.$stateParams.locationId)
      .then(response => {
        ctrl.priceFormula = response.data;
        ctrl.formula = response.data;
      });
  }

  addPrice() {
    const ctrl = this;
    const codePattern = new RegExp('^[A-Z][\A-Z0-9]{2,5}$');

    ctrl.resetNotification();

    if (!codePattern.test(ctrl.tempCode.toUpperCase())) {
      ctrl.notification = {
        type: 'error',
        msg: 'Code is required field and must be between 3 and 6 characters. It should start with a letter and can only contain letters and digits'
      };

      return;
    }
    else if (_find(ctrl.priceLookups, a => a.code === ctrl.tempCode.toUpperCase())) {
      ctrl.notification = {
        type: 'error',
        msg: `Code ${ctrl.tempCode} is already added to the list`
      };

      return;
    }
    else if (!ctrl.tempName || ctrl.tempName.length < 3 || ctrl.tempName.length > 20) {
      ctrl.notification = {
        type: 'error',
        msg: 'Name is required field and must be between 3 and 20 characters'
      };

      return;
    }
    else if (_find(ctrl.priceLookups, a => a.name === ctrl.tempName)) {
      ctrl.notification = {
        type: 'error',
        msg: `Name ${ctrl.tempName} is already added to the list`
      };

      return;
    }
    else {
      ctrl.priceLookups.push({code: ctrl.tempCode.toUpperCase(), name: ctrl.tempName});
      ctrl.tempCode = '';
      ctrl.tempName = '';
    }
  }

  removePrice(price) {
    const ctrl = this;

    if (ctrl.priceFormula && ctrl.priceFormula.includes(`${price.code.toUpperCase()}`)){
      alert('Cannot remove price field as its used in the formula');
    }
    else {
      ctrl.priceLookups = _without(ctrl.priceLookups, price);
    }
  }

  saveChanges() {
    const ctrl = this;

    const priceList = _filter(ctrl.priceLookups, o => o.entityId !== null);

    ctrl.loadingService.showLoading('priceList', 'Updating Price List ...');

    ctrl.priceManagementService.updatePrices(ctrl.$stateParams.locationId, priceList, ctrl.priceFormula)
      .then(response => {
        this.notification = {
          type: 'success',
          msg: 'Prices updated successfully'
        };
      })
      .catch(err => {
        this.notification = {
          type: 'error',
          msg: 'An error occurred while updating prices'
        };
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('priceList');
      });
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  updateFormula() {
    const ctrl = this;
    const pattern = new RegExp(/{(\w*?)}/g);
    let priceLookup;
    let matches;
    let temp = ctrl.formula.toUpperCase();
    let isValid = true;

    while (matches = pattern.exec(ctrl.formula.toUpperCase())) {
      priceLookup = _find(ctrl.priceLookups, o => o.code === matches[1]);
      if (!priceLookup) {
        ctrl.formulaExpression = `Invalid Price Code. ${matches[1]}`;
        isValid = false;
        break;
      }
      temp = temp.replace(matches[0], priceLookup.random);
    }

    if (isValid) {
      ctrl.priceFormula = ctrl.formula.toUpperCase();

      try {
        ctrl.formulaExpression = temp;
        ctrl.formulaEvaluated = eval(temp);
      }
      catch(e) {
        ctrl.formulaExpression = 'Malformed Formula';
        ctrl.formulaEvaluated = '';
      }
    }
  }
}

export default PriceContainerController;



// WEBPACK FOOTER //
// ./client/app/components/priceManagement/priceContainer/priceContainer.controller.js